import React, { useState } from 'react';
import { Container, Typography, Box, Paper, Divider } from '@mui/material';
import LocationSelector from '../components/LocationSelector';
import locationsData from '../json/locations.json';

const LocationTest = () => {
  const [selectedLocation, setSelectedLocation] = useState(null);

  const handleLocationChange = (location) => {
    setSelectedLocation(location);
    console.log('Location changed:', location);
  };

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Typography variant="h4" component="h1" gutterBottom align="center">
        Location Selector Test
      </Typography>
      
      {/* Debug Section */}
      <Paper sx={{ p: 3, mb: 3, bgcolor: 'grey.100' }}>
        <Typography variant="h6" gutterBottom>
          Debug: Raw Data
        </Typography>
        <Typography variant="body2">
          <strong>Total Districts:</strong> {locationsData.districts.length}
        </Typography>
        {locationsData.districts.map((district, index) => (
          <Box key={index} sx={{ ml: 2, mt: 1 }}>
            <Typography variant="body2">
              <strong>{district.bn}</strong> ({district.en}) - {district.upazilas.length} upazilas
            </Typography>
            {district.upazilas.slice(0, 2).map((upazila, uIndex) => (
              <Box key={uIndex} sx={{ ml: 2 }}>
                <Typography variant="caption">
                  • {upazila.bn} ({upazila.en}) - {upazila.bazars.length} bazars
                </Typography>
              </Box>
            ))}
            {district.upazilas.length > 2 && (
              <Typography variant="caption" sx={{ ml: 2, fontStyle: 'italic' }}>
                ... and {district.upazilas.length - 2} more upazilas
              </Typography>
            )}
          </Box>
        ))}
      </Paper>
      
      <Paper sx={{ p: 3, mb: 3 }}>
        <Typography variant="h6" gutterBottom>
          Search Bar Variant
        </Typography>
        <LocationSelector 
          onLocationChange={handleLocationChange}
          variant="search-bar"
          showBazar={true}
        />
      </Paper>

      <Paper sx={{ p: 3, mb: 3 }}>
        <Typography variant="h6" gutterBottom>
          Standalone Variant
        </Typography>
        <LocationSelector 
          onLocationChange={handleLocationChange}
          variant="standalone"
          showBazar={true}
        />
      </Paper>

      <Paper sx={{ p: 3, mb: 3 }}>
        <Typography variant="h6" gutterBottom>
          Without Bazar
        </Typography>
        <LocationSelector 
          onLocationChange={handleLocationChange}
          variant="standalone"
          showBazar={false}
        />
      </Paper>

      {selectedLocation && (
        <Paper sx={{ p: 3, bgcolor: 'success.light' }}>
          <Typography variant="h6" gutterBottom>
            Selected Location:
          </Typography>
          <Typography variant="body1">
            <strong>District:</strong> {selectedLocation.district}
          </Typography>
          <Typography variant="body1">
            <strong>Upazilla:</strong> {selectedLocation.upazilla}
          </Typography>
          <Typography variant="body1">
            <strong>Bazar:</strong> {selectedLocation.bazar}
          </Typography>
        </Paper>
      )}
    </Container>
  );
};

export default LocationTest; 